export default class Payment
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Payment.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$form = this.DOM.$el.querySelector(this.options.selectorPaymentForm)
        this.DOM.$submit = this.DOM.$form.querySelector(this.options.selectorSubmitButton)
        
        let options = {}
        adyen.encrypt.createEncryptedForm(this.DOM.$form, adyen_cse_key, options)
    }
}

Payment.prototype.defaults = {
    selectorPaymentForm: '#adyen-encrypted-form',
    selectorSubmitButton: '.submit-button',
}